import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./shared/styles/global.css";
import "remixicon/fonts/remixicon.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
